import { createApiRef } from '@backstage/frontend-plugin-api';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const cveApiRef = createApiRef<CveApi>().with({
  id: 'cve-api',
  pluginId: 'catalog-devops',
});

export interface CveApi {
  getGithubCve(): Promise<DefaultApiResponse>;
  getRedhatCve(): Promise<DefaultApiResponse>;
}
